import { htmlDecode, htmlEncode } from './escape.utils';

function isBinaryData(value: any): boolean {
  return value instanceof ArrayBuffer || value instanceof Uint8Array;
}

/**
 * Applies fn on every string in data. Knows how to recurse into arrays and other objects.
 *
 * @param data
 * @param fn
 */
function applyFnOnStrings<T>(data: T, fn: (s: string) => any): any {
  if (!data) {
    return data;
  }

  if (typeof data === 'string') {
    return fn(data);
  }

  // This needs to be first because typeof Array is 'object'
  if (Array.isArray(data)) {
    return data.map(value => applyFnOnStrings(value, fn));
  }

  // Do not recurse into binary data - rather, leave it unchanged.
  if (typeof data === 'object' && !isBinaryData(data)) {
    return Object.entries(data).reduce((returnValue, [key, value]) => {
      return {
        ...returnValue,
        [key]: applyFnOnStrings(value, fn),
      };
    }, {});
  }

  return data;
}

export function sanitizeObject<T>(data: T): T {
  return applyFnOnStrings(data, htmlEncode);
}

export function desanitizeObject<T>(data: T): T {
  return applyFnOnStrings(data, htmlDecode);
}

export function sanitizeArray<T>(data: T[]) {
  return applyFnOnStrings(data, htmlEncode);
}
